export const ACTION_PANEL_BUTTON = 'editor/ACTION_PANEL_BUTTON';
